export const centralCommonDataConstants = {
    FETCH_COMMON_DATA: "FETCH_COMMON_DATA",
    CENTRAL_COMMON_DATA_FETCHED: "CENTRAL_COMMON_DATA_FETCHED",
    COMMON_DATA_FAILED: "COMMON_DATA_FAILED",

    UPDATE_COMMON_DATA: "UPDATE_COMMON_DATA",
    CLEAR_CENTRAL_COMMON_DATA: "CLEAR_CENTRAL_COMMON_DATA",
  };
  